import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PropTypes } from 'prop-types';

import EventBus from 'eventbusjs';

import { getMilisecondsFromTimelineLabel } from '../helpers/PlayerHelper';

export default class SoundCloudPlayer extends Component {
  constructor(props) {
    super(props);

    this.autoPlay = this.autoPlay.bind(this);
    this.goToMiliseconds = this.goToMiliseconds.bind(this);
  }

  static propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    url: PropTypes.string,
    autoPlay: PropTypes.bool,
    hideRelated: PropTypes.bool,
    showComments: PropTypes.bool,
    showUser: PropTypes.bool,
    showReposts: PropTypes.bool,
    visual: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
    startAt: PropTypes.number
  };

  static defaultProps = {
    width: '100%',
    height: '132px',
    url: null,
    autoPlay: false,
    hideRelated: false,
    showComments: true,
    showUser: true,
    showReposts: false,
    visual: false,
    color: 'ff5500',
    className: 'podcast'
  };

  componentDidMount() {
    const { startAt } = this.props,
      iframe = this.refs.player,
      widget = SC.Widget(iframe),
      startingPoint = startAt ? startAt : 0;

    this.registerTimelineClickListener(widget);

    widget.bind(SC.Widget.Events.READY, () => {
      this.autoPlay(widget); // Will autoplay if the prop is set to true

      if (startingPoint > 0) {
        this.goToMiliseconds(widget, startingPoint);
        widget.play(); // If time is set, autoplay
      }
    });
  }

  autoPlay(widget) {
    if (this.props.autoPlay) {
      console.log('playing...');
      widget.play();
    }
  }

  goToMiliseconds(widget, startAt) {
    widget.seekTo(startAt);
    widget.play();
  }

  registerTimelineClickListener(widget) {
    const that = this;
    EventBus.addEventListener('PLAY_AT', evnt => {
      const time = evnt.target;
      const miliseconds = getMilisecondsFromTimelineLabel(time);
      that.goToMiliseconds(widget, miliseconds);
    });
  }

  render() {
    const {
      url,
      width,
      height,
      autoPlay,
      hideRelated,
      showComments,
      showUser,
      showReposts,
      visual,
      color,
      className
    } = this.props;

    var src = visual
      ? `https://w.soundcloud.com/player/?url=${url}&amp;auto_play=${autoPlay}&amp;hide_related=${hideRelated}&amp;show_comments=${showComments}&amp;show_user=${showUser}&amp;show_reposts=${showReposts}&amp;visual=${visual}`
      : `https://w.soundcloud.com/player/?url=${url}&amp;color=${color}&amp;auto_play=${autoPlay}&amp;hide_related=${hideRelated}&amp;show_comments=${showComments}&amp;show_user=${showUser}&amp;show_reposts=${showReposts}`;

    return (
      <iframe
        ref="player"
        className={visual ? '' : className}
        width={width}
        height={visual ? height : 'auto'}
        scrolling="no"
        frameBorder="no"
        src={src}
      />
    );
  }
}
